import PropTypes from 'prop-types'
import ButtonComponent from '../../../atoms/button/index.jsx'
import { Edit } from '../../../atoms/icons/core/index.js'
import {
  buttonSizeOptions,
  buttonTypeOptions,
  buttonVariantOptions
} from '../../../atoms/button/constants.js'
import { EditButtonContainer } from './toolbar/styled-components.js'

const TableEditButton = ({ disabled = true, ...props }) => {
  return (
    <EditButtonContainer>
      <ButtonComponent
        size={buttonSizeOptions.SMALL}
        variant={buttonVariantOptions['SECONDARY-WHITE-FILL']}
        buttonType={buttonTypeOptions['ICON-ONLY']}
        style={{ flexShrink: 0 }}
        disabled={disabled}
        {...props}
      >
        <Edit />
      </ButtonComponent>
    </EditButtonContainer>
  )
}

TableEditButton.propTypes = {
  disabled: PropTypes.bool
}

export default TableEditButton
